import { render, staticRenderFns } from "./CreateSlots.vue?vue&type=template&id=4bea3a34&scoped=true"
import script from "./CreateSlots.vue?vue&type=script&lang=js"
export * from "./CreateSlots.vue?vue&type=script&lang=js"
import style0 from "./CreateSlots.vue?vue&type=style&index=0&id=4bea3a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bea3a34",
  null
  
)

export default component.exports